import { mutator, mutatorAction } from 'satcheljs';
import { setCurrentSaveRequestTimeStamp, setIsDarkMode } from 'owa-calendar-compose-form-actions';
import { getComposeStore } from 'owa-calendar-compose-store-manager';

export let setCurrentSaveRequestTimeStampMutator = mutator(
    setCurrentSaveRequestTimeStamp,
    actionMessage => {
        getComposeStore().uiState.currentSaveRequestTimeStamp = actionMessage.timeStamp;
    }
);

export const updateUnresolvedLocation = mutatorAction(
    'resetUnresolvedLocation',
    (updatedLocation: string) => {
        getComposeStore().uiState.unresolvedLocation = updatedLocation;
    }
);

mutator(setIsDarkMode, actionMessage => {
    getComposeStore().uiState.isDarkMode = actionMessage.isDarkMode;
});

export const showExpandedEditor = mutatorAction(
    'showExpandedEditor',
    (showExpandedEditor: boolean) => {
        getComposeStore().uiState.showExpandedEditor = showExpandedEditor;
    }
);
